import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const DateRangePicker = () => {
  const [startDate, setStartDate] = useState(new Date());
  return (
    <DatePicker className="px-5  w-32 rounded-md py-2 " placeholderText="Start Date" selected={startDate} onChange={(date) => setStartDate(date)} />
  );
};

export default DateRangePicker